module.exports = {
    //本地
    // globalBaseUrl: "http://127.0.0.1:9929" // monolith mode: port changed from 9929
    // 服务器
       globalBaseUrl: "https://cross-border.bizspring.cn"
  }


